import React, { useEffect, useState } from 'react'
import CloseIcon from '../../../assets/icons/closeIcon'
import AddRoundIcon from '../../../assets/icons/addRoundIcon'
import Button from '../../../components/globle/button'
import api from '../../../services/api'
import CrudDropdown from '../../../components/globle/crudDropdown'
import LoadingAnimation from '../../../components/globle/loadingAnimation'

const SectionTopic = ({ createdCourseId }) => {
    const [res, setRes] = useState()
    const [courseId, setCourseId] = useState(13)
    const [newSection, setNewSection] = useState("")
    const [newTopic, setNewTopic] = useState("")
    const [imageUploadingLoading, setImageUploadingLoading] = useState(false)
    const [topicVideoUrl, setTopicVideoUrl] = useState("")
    const [currentSectionId, setCurrentSectionId] = useState(0)




    const getCourseRes = async () => {
        const response = await api.getCourseData(createdCourseId);
        if(response.data.success){
            const data = response?.data?.data;
            setRes(data)
        }else{
            alert(response?.data?.message || "Unable to get course")
        }
       

    }
    const createSectionHandle = async () => {
        const data = {
            courseId: createdCourseId,
            name: newSection
        }
        const response = await api.createSection(data);
        if (response?.data?.success) {
            getCourseRes()
            setNewSection("")
            setNewTopic("")
            alert(response.data.message)
        } else {
            alert(response?.data?.message || "Unable to create section")
        }

    }
    const uploadTopicVideoHandle = async (event) => {

        setImageUploadingLoading(true)
        const file = event.target.files[0];


        const data = {
            fileName: file.name,
            ContentType: file.type
        }

        const response = await api.getPresignedUrl(data)
        const presignedUrl = response.data.data;

        const fileData = {
            url: presignedUrl,
            fileType: file.type,
            file: file
        }

        const sendDataResponse = await api.sendDataToS3(fileData)

        if (sendDataResponse) {

            const imageUrl = presignedUrl.split("?")[0]
            setTopicVideoUrl(imageUrl)
        }

        setImageUploadingLoading(false)

    }
    const createTopicHandle = async (sectionId) => {
        const data = {
            sectionId,
            topicName: newTopic,
            videoUrl: topicVideoUrl
        }

        const response = await api.createTopic(data)

        if (response.data.success) {
            getCourseRes()
            setNewTopic("")
            setTopicVideoUrl("")
            alert(response.data.message)
        } else {
            alert(response?.data?.message || "Unable to create topic")
        }

    }
    const deleteTopicHandle = async (topicId) => {

        const data = {
            topicId: topicId
        }
        const response = await api.deleteTopic(data)
        if(response.data.success){
            getCourseRes()
            alert(response.data.message)
        }else{
            alert(response?.data?.message || "Unable to delete topic")
        }
       

    }
    const sectionDeleteHandle = async (sectionId) => {
        const data = {
            sectionId: sectionId
        }
        const response = await api.deleteSection(data)

        if(response.data.success){
            getCourseRes();
            alert(response.data.message)
        }else{
            alert(response?.data?.message || "Unable to delete section")
        }
        

    }

    useEffect(() => {
        getCourseRes()
    }, [])
    return (
        <div
            className='top-cont'
            style={{
                marginTop: "72px",
                display: "flex",
                flexDirection: "column",
                gap: "40px"
            }}
        >


            <div
                style={{
                    display: "flex",

                }}
            >
                <div
                    style={{
                        flex: "0 0 250px",
                        display: "flex",
                        alignItems: "start"
                    }}
                >
                    <p
                        style={{
                            fontSize: "16px",
                            fontFamily: "medium",
                            color: "black",
                            margin: "0"
                        }}
                    >Upload Course</p>
                </div>
                <div
                    style={{
                        width: "-webkit-fill-available",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        flexDirection: "column",
                        gap: "30px"
                    }}
                >
                    {
                        res && res.sections && res.sections.length !== 0 ?
                            res.sections.map((i, index) => {
                                return (
                                    <div
                                        key={index}
                                        style={{
                                            width: "100%"
                                        }}
                                    >
                                        <div
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "10px"
                                            }}
                                        >
                                            <input

                                                value={i.name}
                                                placeholder='Section name'
                                                style={{
                                                    background: "#F6F6F9",
                                                    border: "2px solid #F6F6F9",
                                                    borderRadius: "16px",
                                                    height: "65px",
                                                    width: "100%",
                                                    padding: "0 30px",
                                                    fontSize: "16px",

                                                }}
                                            />
                                            <Button
                                                onClick={() => { sectionDeleteHandle(i.id) }}
                                                title={"delete"} />

                                        </div>

                                        {
                                            i.topics && i.topics.length !== 0 ?

                                                i.topics.map((j, index) => {
                                                    return (
                                                        <div
                                                            key={index}
                                                            style={{
                                                                flexDirection: "column",
                                                                display: "flex",
                                                                gap: "9px",
                                                                width: "100%",
                                                                marginTop: "19px",
                                                                position: "relative"

                                                            }}
                                                        >

                                                            <div
                                                                style={{
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    border: "2px solid #F6F6F9",
                                                                    borderRadius: "16px",
                                                                    height: "65px",
                                                                    width: "100%",
                                                                    padding: "0 0 0 30px",

                                                                }}
                                                            >
                                                                <input
                                                                    value={j.name}

                                                                    placeholder='Topic name'
                                                                    style={{

                                                                        fontSize: "16px",
                                                                        width: "-webkit-fill-available",
                                                                        border: "0",
                                                                        outline: "none"

                                                                    }}
                                                                />
                                                                <div
                                                                    style={{
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        gap: "8px"
                                                                    }}
                                                                >
                                                                    <Button
                                                                        textStyle={{
                                                                            fontSize: "12px",
                                                                            whiteSpace: "nowrap"
                                                                        }}
                                                                        buttonStyle={{
                                                                            height: "40px",
                                                                        }}
                                                                        title={"Upload Video"}
                                                                    />
                                                                    <CrudDropdown getCourseRes={getCourseRes} resources={j} />
                                                                    <CloseIcon
                                                                        onClick={() => deleteTopicHandle(j.id)}
                                                                        style={{
                                                                            marginRight: "20px",
                                                                            marginLeft: "20px",
                                                                            cursor: "pointer"
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div>
                                                            {/* <AddRoundIcon
                                                                style={{
                                                                    position: "absolute",
                                                                    right: "-47px",
                                                                    top: "14px"
                                                                }}
                                                            /> */}



                                                        </div>
                                                    )
                                                })
                                                :
                                                <></>
                                        }
                                        <div
                                            style={{
                                                flexDirection: "column",
                                                display: "flex",
                                                gap: "9px",
                                                width: "100%",
                                                marginTop: "19px",
                                                position: "relative"

                                            }}
                                        >

                                            <div
                                                style={{
                                                    alignItems: "center",
                                                    border: "2px solid #F6F6F9",
                                                    borderRadius: "16px",
                                                    height: "65px",
                                                    width: "100%",
                                                    padding: "0 0 0 30px",
                                                    display: currentSectionId === index ? "flex" : "none",
                                                }}
                                            >
                                                <input

                                                    value={newTopic}
                                                    onChange={(i) => setNewTopic(i.target.value)}
                                                    placeholder='Topic name'
                                                    style={{

                                                        fontSize: "16px",
                                                        width: "-webkit-fill-available",
                                                        border: "0",
                                                        outline: "none"

                                                    }}
                                                />
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        gap: "8px"
                                                    }}
                                                >
                                                    <input
                                                        onChange={uploadTopicVideoHandle}
                                                        accept="video/*"
                                                        type='file' />
                                                    {
                                                        imageUploadingLoading ?
                                                            <div
                                                                style={{
                                                                    position: "absolute",
                                                                    width: "20px",
                                                                    height: "20px",
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "center"
                                                                }}
                                                            >
                                                                <LoadingAnimation
                                                                    animateColor={"black"}
                                                                    backAnimateColor={"white"}
                                                                    borderWidth={"2px"}
                                                                    style={{
                                                                        width: "20px",
                                                                        height: "20px",

                                                                    }}
                                                                />
                                                            </div> : <></>
                                                    }

                                                </div>
                                            </div>




                                        </div>
                                        <div
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "space-between",
                                                width: "100%",
                                                marginTop: "20px"
                                            }}
                                        >
                                            <Button
                                                onClick={() => createTopicHandle(i.id)}
                                                title={"Add topic"} />
                                            <Button
                                                onClick={() => {
                                                    setCurrentSectionId(index)
                                                    setTopicVideoUrl("")
                                                }}
                                                title={"+ plus"} />
                                        </div>
                                    </div>
                                )
                            })
                            :
                            <></>
                    }


                    <div
                        style={{
                            width: "100%"
                        }}
                    >
                        <input
                            value={newSection}
                            onChange={(i) => setNewSection(i.target.value)}
                            placeholder='Section name'
                            style={{
                                border: "2px solid black",
                                borderRadius: "16px",
                                height: "65px",
                                width: "100%",
                                padding: "0 30px",
                                fontSize: "16px",

                            }}
                        />

                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                width: "100%",
                                marginTop: "20px"
                            }}
                        >
                            <Button
                                onClick={() => createSectionHandle()}
                                title={"+ Create Section"}
                            />
                        </div>
                    </div>

                </div>
            </div>

        </div>
    )
}

export default SectionTopic